import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const getCurrencyFromStorage = () => {
  try {
    return localStorage.getItem('selectedCurrency') || 'AED';
  } catch (error) {
    return 'AED';
  }
};

// Fetch live exchange rates from API
export const fetchExchangeRates = createAsyncThunk(
  'currency/fetchExchangeRates',
  async () => {
    try {
      // Using exchangerate-api.com free tier (AED as base currency)
      const response = await fetch('https://api.exchangerate-api.com/v4/latest/AED');
      const data = await response.json();
      return {
        rates: data.rates,
        timestamp: Date.now(),
      };
    } catch (error) {
      console.error('Failed to fetch exchange rates:', error);
      // Fallback rates (approximate, updated Aug 2024)
      return {
        rates: {
          AED: 1,
          USD: 0.272,
          EUR: 0.248,
          GBP: 0.213,
          INR: 22.76,
          SAR: 1.02,
        },
        timestamp: Date.now(),
      };
    }
  }
);

const initialState = {
  selectedCurrency: getCurrencyFromStorage(),
  exchangeRates: {
    AED: 1,
    USD: 0.272,
    EUR: 0.248,
    GBP: 0.213,
    INR: 22.76,
    SAR: 1.02,
  },
  ratesLastFetched: null,
  ratesFetching: false,
};

const currencySlice = createSlice({
  name: 'currency',
  initialState,
  reducers: {
    setCurrency: (state, action) => {
      state.selectedCurrency = action.payload;
      localStorage.setItem('selectedCurrency', action.payload);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExchangeRates.pending, (state) => {
        state.ratesFetching = true;
      })
      .addCase(fetchExchangeRates.fulfilled, (state, action) => {
        state.exchangeRates = action.payload.rates;
        state.ratesLastFetched = action.payload.timestamp;
        state.ratesFetching = false;
      })
      .addCase(fetchExchangeRates.rejected, (state) => {
        state.ratesFetching = false;
      });
  },
});

export const { setCurrency } = currencySlice.actions;
export default currencySlice.reducer;
